import { OnboardingService } from '@nextforce/api'
import { useServer } from 'app/server/context'
import React, { createContext, useContext } from 'react'

export const OnboardingContext = createContext({} as OnboardingService)

interface Props {
  children: React.ReactNode
}

export function OnboardingProvider(props: Props) {
  const { server } = useServer()

  if (!server) {
    return null
  }

  return (
    <OnboardingContext.Provider value={new OnboardingService(server)}>
      {props.children}
    </OnboardingContext.Provider>
  )
}

export function useOnboarding() {
  return useContext<OnboardingService>(OnboardingContext)
}
